export default "__VITE_ASSET__BsLq7QFU__"